/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import React, { useState, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Card from '@material-ui/core/Card';
import BasePage from './BasePage';
import EpiSourceLogo from '../../assets/images/logo@2x-1-300x71.png';

const useStyles = makeStyles(theme => ({
  cont: {
    display: 'relative',
    // height: 200,
  },
  container: {
    margin: 0,
    position: 'absolute',
    top: '50%',
    left: '50%',
    msTransform: 'translate(-50%, -50%)',
    transform: 'translate(-50%, -50%)',
  },
  paper: {
    margin: theme.spacing(3),
  },
  cardBG: {
    backgroundColor: '#f1f3f4',
    margin: 'none',
  },
  imgContainer: {
    backgroundColor: '#263238',
  },
  imgIcon: {
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
  textSection: {
    height: 200,
    textJustify: 'inter-word',
    alignItems: 'center',
    overflowY: 'scroll',
    paddingBottom: theme.spacing(3),
  },
  title: {
    paddingBottom: theme.spacing(3),
  },
  form: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));

export default function PrivacyCheck() {
  const classes = useStyles();
  const [auth0State, setAuth0State] = useState(null);
  const [isClicked, setIsClicked] = useState(false);
  // function to decode auth0 url state
  const getURLState = () => {
    const URL = window.location.href;
    if (URL.includes('state')) {
      const params = URL.split('?')[1].split('&');
      for (const idx in params) {
        const pair = params[idx].split('=');
        if (pair[0] === 'state') {
          setAuth0State(pair[1]);
        }
      }
    }
  };

  useEffect(() => {
    getURLState();
  });

  const redirectURL = `https://${process.env.REACT_APP_DOMAIN}/continue?state=${auth0State}`;
  return (
    <>
      <BasePage className={classes.cont}>
        <Container className={classes.container}>
          <Card className={classes.cardBG}>
            <div className={classes.paper}>
              <div className={classes.imgContainer}>
                <img className={classes.imgIcon} src={EpiSourceLogo} />
              </div>
              <Typography variant="h1" component="h2" className={classes.title}>
                Episource Privacy Terms
              </Typography>
              <div className={classes.textSection}>
                <Typography variant="h3" component="h2">
                  Access Disclaimer
                </Typography>
                <br />
                <Typography variant="body1">
                  You are now accessing Episource online information.
                  <br />
                  We think it is important for you to know how we handle information we communicate
                  via the Internet.This statement outlines our practices and our sensitivity to your
                  right to privacy. We reserve the right to revoke access at any time for any
                  reason.
                </Typography>
                <br />
                <Typography variant="h3" component="h2">
                  Response to Electronic Communication
                </Typography>
                <br />
                <Typography variant="body1">
                  Episource will make its best effort to provide a timely response to electronic
                  inquiries. Accordingly, emergency situations requiring immediate attention should
                  not be submitted electronically.
                  <br />
                  Furthermore, with respect to any electronic communications which you send, we are
                  only able to respond to such communications based on the information you provide.
                  If there is insufficient information provided, we will be unable to provide
                  accurate and reliable services.
                </Typography>
                <br />
                <Typography variant="h3" component="h2">
                  E-mail Privacy
                </Typography>
                <br />
                <Typography variant="body1">
                  Notification messages regarding information that Episource manages may be sent to
                  your e-mail address. Only an authorized person with access to this e-mail account
                  should view this notification. Please take this into account when reviewing e-mail
                  messages or sending them.
                </Typography>
                <br />
                <Typography variant="h3" component="h2">
                  Security and Confidentiality
                </Typography>
                <br />
                <Typography variant="body1">
                  We afford the same degree of confidentiality to medical and proprietary
                  information stored on Episource systems as is given to medical information stored
                  by Episource systems in any other medium. Episource is committed to protecting the
                  confidentiality of this information. We limit Episource employees’ access and
                  ability to enter or view information based upon their role in our organization.
                  Firewalls, passwords, encryption, and audit trails are further used to safeguard
                  all information. We shall identify the records accessed and note the time and date
                  of access each time an employee accesses Episource systems. We have taken steps to
                  make all information received from and to employees are as secure as possible
                  against unauthorized access and use.
                </Typography>
                <br />
                <Typography variant="h3" component="h2">
                  Privacy Notice
                </Typography>
                <br />
                <Typography variant="body1">
                  This privacy notice discloses the privacy practices for Episource. This privacy
                  notice applies solely to information collected by Episource.com. It will notify
                  you of the following:
                </Typography>
                <ol>
                  <li>
                    {' '}
                    What personally identifiable information is collected from you through the
                    website, how it is used and with whom it may be shared.
                  </li>
                  <li>What choices are available to you regarding the use of your data.</li>
                  <li>
                    The security procedures in place to protect the misuse of your information.
                  </li>
                  <li>How you can correct any inaccuracies in the information.</li>
                </ol>
                <br />
                <Typography variant="h3" component="h2">
                  Information Collection, Use, and Sharing
                </Typography>
                <br />
                <Typography variant="body1">
                  Episource is the sole owners of the information collected on this site. We only
                  have access to/collect information that you voluntarily give us via email or other
                  direct contact from you. We will not sell or rent this information to anyone.
                  <br />
                  Episource will use your information to respond to you, regarding the reason you
                  contacted us. We will not share your information with any third party outside of
                  our organization, other than as necessary to fulfill your request, e.g. to ship an
                  order.
                  <br />
                  Unless you ask us not to, Episource may contact you via email in the future to
                  tell you about specials, new products or services, or changes to this privacy
                  policy.
                </Typography>
                <br />
                <Typography variant="h3" component="h2">
                  Your Access to and Control Over Information
                </Typography>
                <br />
                <Typography variant="body1">
                  You may opt out of any future contacts from Episource at any time. You can do the
                  following at any time by contacting us via the email address or phone number given
                  on our website:
                </Typography>
                <ul>
                  <li>See what data we have about you, if any.</li>
                  <li>Change/correct any data we have about you.</li>
                  <li>Have us delete any data we have about you.</li>
                  <li>Express any concern you have about our use of your data.</li>
                </ul>
                <br />
                <Typography variant="h3" component="h2">
                  Reporting Security Concerns
                </Typography>
                <br />
                <Typography variant="body1">
                  Episource takes precautions to protect your information. When you submit sensitive
                  information via the website, your information is protected both online and
                  offline.
                </Typography>
                <br />
                <b>
                  If you feel that we are not abiding by this privacy policy, you should contact us
                  immediately via telephone at
                  <a href="https://www.google.com/search?q=episource&oq=ep&aqs=chrome.0.69i59j69i60j69i61l2j69i60j69i57.1988j0j7&sourceid=chrome&ie=UTF-8#">
                    <b> (714) 452-1961 </b>
                  </a>
                  or at https://www.episource.com/contact/
                </b>
              </div>
              <form className={classes.form} action={redirectURL} method="post">
                <div className="checkbox">
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label>
                    <input
                      type="checkbox"
                      name="confirm"
                      value="yes"
                      onClick={() => setIsClicked(!isClicked)}
                    />{' '}
                    I Accept Episource Privacy Terms.
                  </label>
                </div>
                <input
                  disabled={!isClicked}
                  type="submit"
                  className="btn btn-lg btn-success"
                  value="Continue"
                />
              </form>
            </div>
          </Card>
        </Container>
      </BasePage>
    </>
  );
}
